import { createCrewLookupSelect } from './createCrewLookupSelect';

export const CertCatalogSelect = createCrewLookupSelect('CertCatalogSelect', 'certCatalogs');
export default CertCatalogSelect;
